import { render, staticRenderFns } from "./WidgetConversationAverage.vue?vue&type=template&id=6c7fe322&scoped=true&"
import script from "./WidgetConversationAverage.vue?vue&type=script&lang=js&"
export * from "./WidgetConversationAverage.vue?vue&type=script&lang=js&"
import style0 from "./WidgetConversationAverage.vue?vue&type=style&index=0&id=6c7fe322&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7fe322",
  null
  
)

export default component.exports